// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-data-container .title-list-heading {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #FFFFFF;
  margin-bottom: 8px;
  margin-top: 10px;
}

.search-temp-one .temp-data-desc {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 0px 0 0px 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  position: relative;
}

.search-temp-one .temp-data-desc .read-more-less {
  position: absolute;
  right: 4px;
  bottom: 0px;
  padding: 0 0px 0 4px;
  color: #F4D8CF;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  background: #56070C;
  text-decoration: underline;
}

.search-temp-one .snippet-source-block .snippet-source-file-name {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  padding: 20px 0 10px 0;
}

.search-temp-one .snippet-source-block a {
  text-decoration: none !important;
}

.search-temp-one .snippet-source-block .snippet-source-url {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px 10px;
  box-shadow: 0px 0px 11px rgb(157, 29, 39);
  border-radius: 4px;
  justify-content: space-between;
  margin-bottom: 0;
}

.search-temp-one .snippet-source-block .snippet-source-url .snippet-source-url-name {
  color: var(--sdk-chat-window-bot-bubble-font-clr);
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  text-decoration: none !important;
}

.search-temp-one .snippet-source-block .snippet-source-url img {
  padding: 0 !important;
}

.show-more-results-block {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

.show-more-results-block span {
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: #fff;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  padding: 5px 10px;
  cursor: pointer;
  background: #9d1d27;
}

.parent-list-template {
  display: inline-block;
  width: 100%;
}

.parent-list-template .click-to-navigate-url {
  /* box-shadow: 0px 0px 11px #9d1d27; */
  border-radius: 6px;
  padding: 10px 15px;
  margin-bottom: 10px;
  padding-left: 60px;
  min-height: 60px;
  position: relative;
  cursor: pointer;
  background: #fff;
  color: #25243b;
}

.parent-list-template .click-to-navigate-url .img_block {
  position: absolute;
  left: 15px;
  width: 35px;
  height: 35px;
  top: 14px;
}

.parent-list-template .click-to-navigate-url .img_block img {
  width: 100%;
  height: 100%;
  border-radius: 3px;
  padding: 0;
  object-fit: fill;
}

.parent-list-template .click-to-navigate-url .heading-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.parent-list-template .click-to-navigate-url .desc_text_info {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/solutions/templates/SearchResultsTemplate/searchResults.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AACE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;AAEJ;;AAAE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAGJ;;AADE;EACE,gCAAA;AAIJ;;AAFE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AAKJ;;AAHE;EACE,iDAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;AAMJ;;AAJE;EACE,qBAAA;AAOJ;;AAJE;EACE,aAAA;EACA,yBAAA;EACA,cAAA;AAOJ;;AAJE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAOJ;;AAJE;EACE,qBAAA;EACA,WAAA;AAOJ;;AALE;EACE,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAQJ;;AANE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AASJ;;AAPE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAUJ;;AARE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAWJ;;AATE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAYJ","sourcesContent":[".search-data-container .title-list-heading {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    color: #FFFFFF;\n    margin-bottom: 8px;\n    margin-top: 10px;\n  }\n  \n  .search-temp-one .temp-data-desc {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    padding: 0px 0 0px 0;\n    word-break: break-word;\n    display: -webkit-box;\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    position: relative;\n  }\n  .search-temp-one .temp-data-desc .read-more-less {\n    position: absolute;\n    right: 4px;\n    bottom: 0px;\n    padding: 0 0px 0 4px;\n    color: #F4D8CF;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    cursor: pointer;\n    background: #56070C;\n    text-decoration: underline;\n  }\n  .search-temp-one .snippet-source-block .snippet-source-file-name {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    padding: 20px 0 10px 0;\n  }\n  .search-temp-one .snippet-source-block a {\n    text-decoration: none !important;\n  }\n  .search-temp-one .snippet-source-block .snippet-source-url {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 7px 10px;\n    box-shadow: 0px 0px 11px rgba(157, 29, 39, 1);\n    border-radius: 4px;\n    justify-content: space-between;\n    margin-bottom: 0;\n  }\n  .search-temp-one .snippet-source-block .snippet-source-url .snippet-source-url-name {\n    color: var(--sdk-chat-window-bot-bubble-font-clr);\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    text-decoration: none !important;\n  }\n  .search-temp-one .snippet-source-block .snippet-source-url img {\n    padding: 0 !important;\n  }\n  \n  .show-more-results-block{\n    display: flex;\n    justify-content: flex-end;\n    margin: 10px 0;\n  }\n  \n  .show-more-results-block span{\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 12px;\n    color: #fff;\n    border-radius: 20px;\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    padding: 5px 10px;\n    cursor: pointer;\n    background: #9d1d27;\n  }\n  \n  .parent-list-template {\n    display: inline-block;\n    width: 100%;\n  }\n  .parent-list-template .click-to-navigate-url {\n    /* box-shadow: 0px 0px 11px #9d1d27; */\n    border-radius: 6px;\n    padding: 10px 15px;\n    margin-bottom: 10px;\n    padding-left: 60px;\n    min-height: 60px;\n    position: relative;\n    cursor: pointer;\n    background: #fff;\n    color: #25243b;\n  }\n  .parent-list-template .click-to-navigate-url .img_block {\n    position: absolute;\n    left: 15px;\n    width: 35px;\n    height: 35px;\n    top: 14px;\n  }\n  .parent-list-template .click-to-navigate-url .img_block img {\n    width: 100%;\n    height: 100%;\n    border-radius: 3px;\n    padding: 0;\n    object-fit: fill;\n  }\n  .parent-list-template .click-to-navigate-url .heading-title {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .parent-list-template .click-to-navigate-url .desc_text_info {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    margin-top: 4px;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
